import React, { useState } from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import AnnouncementBar from './AnnouncementBar';
import FloatingCTA from './FloatingCTA';

const Layout = ({ children }) => {
    const [showAnnouncementBar, setShowAnnouncementBar] = useState(true);

    return (
        <div className="min-h-screen bg-white font-sans flex flex-col">
            {showAnnouncementBar && (
                <AnnouncementBar onClose={() => setShowAnnouncementBar(false)} />
            )}
            <Navigation />
            <main className="flex-grow">
                {children}
            </main>
            <Footer />
            <FloatingCTA />
        </div>
    );
};

export default Layout;
